import { render, staticRenderFns } from "./MapaPage.vue?vue&type=template&id=11c1a250&"
import script from "./MapaPage.vue?vue&type=script&lang=js&"
export * from "./MapaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports